<template>
<div class="clum2right left">
  <div id="content_block" class="left">
    <div class="sync_icon left"> </div>
    <div class="content_title left">Maps & Updates</div>
    <div id="content_main" class="left">
      <div class="pure-form pure-form-stacked">
        <fieldset>
          <p class="synctext">Select your device to view available map contents.</p>
          <select id="state" class="pure-input-1-2" v-model="indexDevice" @change="selectDevice()">
								<option v-for="(device, index) in devices" v-bind:value="index" style="cursor: pointer;">{{device.uuid}}</option>
					</select>
          <p v-if="isHaveDevice" style="font-size: 14px; line-height: 20px;">
            UUID: {{device.uuid}}<br> DeviceID: {{device.device_id}}<br> Warranty Period: {{device.fud.substring(0,10)}}~{{device.expired.substring(0,10)}}</p>
          <p v-else style="color: #FF5B00;">Cannot find any device in your account.<br> Please login to update tool and bind your device.</p>

        </fieldset>
      </div>
      <div class="tab_container" v-show="isHaveDevice">
        <input id="tab1" type="radio" name="tabs" checked>
        <label for="tab1"><span>My Maps</span></label>
        <input id="tab2" type="radio" name="tabs">
        <label for="tab2" style="margin-left:-3.5px;"><span>Optional Maps</span></label>

        <section id="content1" class="tab-content">
          <table class="tab_table">
            <thead>
              <tr>
                <th class="tab_tableline">Map Region</th>
                <th class="tab_tableline">Map Version</th>
                <th class="tab_tableline">Model Name</th>
                <th class="tab_tableline">Purchase Date</th>
                <th class="tab_tableline">Order Number</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in version_mymaps" track-by="map_version">
                <td class="tab_tableline">{{ item.map_name }}</td>
                <td class="tab_tableline">{{ item.map_version }}</td>
                <td class="tab_tableline">{{ item.model }}</td>
                <td class="tab_tableline">{{item.purchase_date?item.purchase_date:'Free'}}</td>
                <td class="tab_tableline">{{item.order_no?item.order_no:'Free'}}</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section id="content2" class="tab-content">
          <table class="tab_table">
            <thead>
              <tr>
                <th class="tab_tableline">Map Region</th>
                <th class="tab_tableline">Map Version</th>
                <th class="tab_tableline">Model Name</th>
                <th class="tab_tableline">Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in version_newmaps">
                <td class="tab_tableline">{{ item.map_name }}</td>
                <td class="tab_tableline">{{ item.map_version }}</td>
                <td class="tab_tableline">{{ item.model }}</td>
                <td class="tab_tableline" v-if="item.price!=''">
                  <!-- <button @click="buyNothing(item)" style="cursor: pointer;">
    														<i class="fa fa-shopping-cart btn_icon"></i> -->
    														{{item.price? item.price:'Free'}}
    									<!-- </button> -->
                </td>
                <td v-else>
                  <span>Free</span>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/*jshint esversion: 6 */
// import 'babel-polyfill';
import {
  getDataUrl
} from '../../../tools/getUrl.js';
export default {
  data: function() {
    return {
      indexDevice: 0,
      devices: [],
      device: {},
      mymaps: [],
      newmaps: [],
      uuid: ''
    };
  },
  computed: {
    isHaveDevice: function() {
      if (!!this.device.model) {
        return true;
      }
      return false;
    },
    version_mymaps: function() {
      return this.mymaps.map(function(objMap) {
        var _objMap = objMap,
          str = objMap.map_version,
          index = str.indexOf('.'),
          subStr = str.substring(str.indexOf('.') + 3);
        _objMap.map_version = _objMap.map_version + ' (' + (2008 + parseInt(subStr.substring(0, 2))) + 'Q' + parseInt(subStr.substring(2, 3)) + ')';

        return _objMap;
      });
    },
    version_newmaps: function() {
      return this.newmaps.map(function(objMap) {
        var _objMap = objMap,
          str = objMap.map_version,
          index = str.indexOf('.'),
          subStr = str.substring(str.indexOf('.') + 3);
        _objMap.map_version = _objMap.map_version + ' (' + (2008 + parseInt(subStr.substring(0, 2))) + 'Q' + parseInt(subStr.substring(2, 3)) + ')';

        return _objMap;
      });
    }
  },
  methods: {
    initData: function() {
      var obj = {
          api: 'get_device',
          account_id: sessionStorage.getItem('accountid'),
          output: 'json'
        },
        url = getDataUrl(obj);
      this.$http.get(url).then((response) => {
        // success callback
        var arrDevices = JSON.parse(response.data).devices;
        if (!!arrDevices && arrDevices.length > 0) {
          this.devices = arrDevices;
          this.selectDevice();
        } else {
          this.devices = [{
            uuid: 'Car Model:N/A'
          }];
        }

      }, (response) => {
        // error callback
      });
    },
    buyNothing: function(item) {

    },
    buyOnline: function(item) {
      var strVersion = item.map_version.substring(0, item.map_version.indexOf('('));
      // console.log(strVersion);
      var obj = {
        api: 'buy_online',
        email: sessionStorage.getItem('email'),
        model: item.model,
        uuid: this.uuid,
        map_version: strVersion
      };
      var url = getDataUrl(obj);
      this.$http.get(url).then((response) => {
        // console.log(response.body);
        document.location.assign(response.body.toString());
      }, (response) => {
        // error callback
      });
    },
    selectDevice: function() {
      var index = this.indexDevice;
      this.device = this.devices[index];
      var _model = this.devices[index].model,
        _uuid = this.devices[index].uuid,
        obj = {
          api: 'get_downloadable_map',
          account_id: sessionStorage.getItem('accountid'),
          model: _model,
          uuid: _uuid,
          output: 'json'
        },
        url = getDataUrl(obj);
      this.uuid = _uuid;
      this.$http.get(url).then((response) => {
        // success callback
        this.mymaps = JSON.parse(response.data).maps;
        obj = {
          api: 'get_new_map',
          account_id: sessionStorage.getItem('accountid'),
          model: _model,
          uuid: _uuid,
          output: 'json'
        };
        url = getDataUrl(obj);
        this.$http.get(url).then((response) => {
          // success callback
          this.newmaps = JSON.parse(response.data).maps;
        }, (response) => {
          // error callback
        });
      }, (response) => {
        // error callback
      });
    }
  },
  mounted() {
    this.initData();
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
}

.tab_container {
  position: relative;
}

.tab_container input,
.tab_container section {
  clear: both;
  display: none;
}

.tab_container label {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  padding: 10px 12px;
  text-decoration: none;
  transition: 0.3s;
  font-size: 16px;
  width: 120px;
  font-family: 'Roboto', sans-serif;
  color: #FFF;
  box-shadow: inset 0 55px #999;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

#tab1:checked~#content1,
#tab2:checked~#content2 {
  display: block;
  background: #fff;
  /*border-bottom: 2px solid #f0f0f0;*/
}

.tab_container [id^="tab"]:checked+label {
  background: #fff;
  box-shadow: inset 0 55px #0D3F92;
}

.tab_container tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// Maps.vue?3be7bade